module.exports = __webpack_public_path__ + "static/media/teDelAlma.7b98dc1e.png";